import { ArrowUpIcon } from "@heroicons/react/24/outline";
import { useScrollY } from "../../hooks/useScrollY";

export default function TopButton() {
    const scrollTarget = 300;
    const scrollY = useScrollY({
        delay: 250
    });

    if (scrollY < scrollTarget) {
        return <></>;
    }

    return <button type="button" onClick={() => window.scrollTo(0, 0)} className="fixed bottom-20 z-50 right-8 px-3 py-3 bg-emphasis hover:bg-emphasis-secondary text-white rounded shadow-md drop-shadow-md">
        <ArrowUpIcon className="h-5 w-5" stroke="white" strokeWidth="4" />
    </button>
}